import { AxiosPromise } from 'axios';
import baseRequest from './baseRequest';

interface BusinessMessage {
  category: string;
  description: string;
  type?: 'AprDisclaimer' | 'CharmMessage';
}

export interface UpfrontRateResponse {
  apr: number;
  businessMessages: BusinessMessage[];
  displayName: string;
  interestRate: number;
  monthlyPayment: number;
}

export function getUpfrontRates(params): AxiosPromise<UpfrontRateResponse[]> {
  return baseRequest.get('/api/products/upfront-rates', { params });
}
